/** This is a syntactic sugar for `headerRow` prop. So HOC will not work on this. */
// tslint:disable-next-line:function-name
function HeaderRow(_) {
  return null;
}
HeaderRow.defaultProps = {
  __isHeaderRow: true
};
export default HeaderRow;